import { format } from "date-fns";
import api from "./api";


export const getAllHolidays = async (state, year) => {
    const response = await api.get(`/api/holiday/state/${state}/year/${year}`);
    return response;
}

export const getApprovedLeaves = async (employeeId) => {
    //  http://localhost:8080/api/leaves/approved?employeeId=4G-20251016951273
    const response = await api.get(`api/leaves/approved?employeeId=${employeeId}`);
    return response.data;
}
// services/leaveService.js


export const getFilteredApprovedLeaves = async (filters) => {
    const { employeeId, stateId, status, fromDate, toDate, districtId } = filters;

    try {
        // Start with required params
        let url = `/api/leaves/approved/filter?employeeId=${employeeId}&stateId=${stateId}&fromDate=${fromDate}&toDate=${toDate}`;

        // Append optional params if they exist
        if (status) {
            // API expects lowercase usually, adjust if your backend needs "Approved"
            url += `&status=${status.toLowerCase()}`;
        }
        if (districtId) {
            url += `&districtId=${districtId}`;
        }

        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching filtered leaves:", error);
        throw error;
    }
};


export const getFilteredApprovedLeavesReport = async (filters) => {
    const { employeeUniqueId, stateId, status, fromDate, toDate, districtId, clientId,projectId } = filters;

    try {
        // Start with required params
        let url = `/api/leaves/reports?&stateId=${stateId}&fromDate=${fromDate}&toDate=${toDate}`;

        // Append optional params if they exist

        if (status) {
            // API expects lowercase usually, adjust if your backend needs "Approved"
            url += `&status=${status.toLowerCase()}`;
        }
          if (clientId) {
            // API expects lowercase usually, adjust if your backend needs "Approved"
            url += `&client=${clientId}`;
        }
        if (districtId) {
            url += `&districtId=${districtId}`;
        }
        if (employeeUniqueId) {
            url += `&employeeId=${employeeUniqueId}`;
        }
         if (projectId) {
            url += `&projectId=${projectId}`;
        }

        const response = await api.get(url);
        const employeeData = Array.isArray(response.data)
            ? response.data
            : response.data.employeeWiseReport || [];

        return employeeData.map(item => ({
            ...item,
            casualLeave: item.casualLeave || 0,
            absentDays: item.absentDays || 0,
        }));
    } catch (error) {
        console.error("Error fetching filtered leaves:", error);
        throw error;
    }
};

export const updateHolidays = async (editHolidayId, holidayData) => {
    const response = await api.put(`/api/holiday/update/${editHolidayId}`, holidayData)
    return response;
}


export const createNewHoliday = async (holidayData) => {
    const response = await api.post(`/api/holiday/submit`, holidayData)
    return response;
}
export const deleteHoliday = async (holidayId) => {
    try {
        const response = await api.delete(`/api/holiday/delete/${holidayId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting holiday:", error);
        throw error;
    }
};
export const getLeaves = async (employeeId, roleItem) => {

    try {
        const response = await api.get(`/api/leaves/pending-for-approval?approverUniqueId=${employeeId}&role=${roleItem}`);
        return response.data;
    } catch (error) {
        console.error("Error getting leaves:", error);
        throw error;
    }
}

//  await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/leaves/approve`,payload,{headers: { "Content-Type": "application/json" },});
export const updateLeavesApprove = async (payload) => {
    await api.put(`/api/leaves/approve`, payload, {
        headers: { "Content-Type": "application/json" }
    });
}
export const rejectLeave = async (payload) => {
    await api.put(`/api/leaves/reject`, payload, {
        headers: { "Content-Type": "application/json" }
    });
}

export const getLeaveBalanceByEmployeeId = async (employeeId) => {
    const response = await api.get(`/api/leaves/eligibility/${employeeId}`)
    return response.data;
}

export const getLeavesBasedonEmployeeId = async (employeeId) => {
    const response = await api.get(`/api/leaves/employee/${employeeId}`)
    return response.data;

};

export const getApprovedLeavesBasedonEmployeeId = async (employeeId) => {
    const response = await api.get(`/api/leaves/approved/employee/${employeeId}`);
    return response.data;

};

export const updateLeavesRequest = async (payload) => {

    await api.put(`/api/leaves/update-leave`, payload, {
        headers: { "Content-Type": "application/json" }
    })
}
export const createLeaveRequest = async (payload) => {
    const response = await api.post(`/api/leaves/apply`, payload, {
        headers: { "Content-Type": "application/json" }
    });
    return response;

};

export const cancelLeaveRequestr = async (leaveId, payload) => {
    const response = await api.post(`/api/leaves/${leaveId}/cancel`, payload);
    return response;

}

export const leavesReport = async (year, month) => {
    const response = await api.get(`/api/leaves/report?year=${year}&month=${month}`)
    return response.data;

}

export const leaveHistroyReport = async (stateId, districtId, draftId,tillDate) => {
    try {
        // Format dates to YYYY-MM-DD
       // const formattedFromDate = tillDate ? format(tillDate, 'yyyy-MM-dd') : '';
        const formattedToDate = tillDate ? format(tillDate, 'yyyy-MM-dd') : '';
        
        const response = await api.get('/api/leaves/leavehistory', {
            params: {
                stateId: stateId,
                districtId: districtId,
                employeeUniqueId: draftId,
               // fromDate: formattedFromDate,
                toDate: formattedToDate
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error in terminationReportEmployee:", error);
        throw error;
    }
}